module.exports = __webpack_public_path__ + "img/pen_line.797e0399.svg";